module.exports = __webpack_public_path__ + "static/media/death-certificate.e9fa921a.mp3";